module.exports = __webpack_public_path__ + "img/reco5.133568a6.jpg";